export default __webpack_public_path__ + "static/media/marketplace.d61ab982.svg";